"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=707%3A861))
 * @lastsynced 2023-07-10T21:44:59.385Z
 */
export const Button = createSVGIcon(
  <>
    <path
      d="M20 17.259L16.3074 13.555L18.1537 11.703C18.2699 11.585 18.3523 11.4379 18.3924 11.2769C18.4325 11.116 18.4288 10.9472 18.3816 10.7883C18.3345 10.6293 18.2456 10.4859 18.1243 10.3732C18.003 10.2605 17.8537 10.1825 17.6921 10.1474L9.14376 8.02683C8.98952 7.98875 8.8281 7.99124 8.6751 8.03405C8.5221 8.07687 8.3827 8.15856 8.27038 8.27122C8.15807 8.38388 8.07663 8.52371 8.03395 8.67718C7.99127 8.83065 7.98879 8.99257 8.02675 9.14729L10.1408 17.722C10.1807 17.8812 10.262 18.0268 10.3765 18.1441C10.491 18.2613 10.6344 18.3459 10.7922 18.3892C10.95 18.4326 11.1164 18.4331 11.2745 18.3907C11.4325 18.3483 11.5765 18.2645 11.6917 18.148L13.538 16.296L17.2306 20L20 17.259Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 12H3.84967C3 12 2 11.3846 2 10V6C2 4.5 3 4 4.5 4H20C21 4 22 4.5 22 6V10C22 11.5 21 12 20 12H18"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Button",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Add button",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  })
);
